import React from "react";
import PropTypes from "prop-types";
import ConfirmationDialogComponent from "./confirmationDialog.component";

function ConfirmationDialogContainer({
  isOpen,
  handleClose,
  handleProceed,
  title,
}) {
  return (
    <ConfirmationDialogComponent
      isOpen={isOpen}
      handleClose={handleClose}
      handleProceed={handleProceed}
      title={title}
    />
  );
}

ConfirmationDialogContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleProceed: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default ConfirmationDialogContainer;
